<template>
  <div style="overflow-x: hidden;">
    
    <CRow>
      <CCol md="12">
        <CCard class="main_plan_letters">
          <hr class="plan_horizon"/>
          <CCardHeader>
            {{ $t('This page is not allowed for your current membership plan.') }}
          </CCardHeader>
          <CCardBody>
                {{ $t('Please upgrade your plan') }} <a :href="membership_pg_url" target="_blank" >{{ $t('here') }}</a> {{ $t('or contact the administrator') }}
          </CCardBody>
        </CCard>
        <div class="plan_button_parent">
          <button class="upgrage_plan"><a :href="membership_pg_url" target="_blank" >{{ $t('Upgrade plan') }}</a></button>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';


  export default {
    name: 'Membership',   
    data () {
      return {
        membership_pg_url: ''
        
      }
    },
    created() {
      //this.authorize()
      this.getMembershipUrl()
    },
    methods: {
      ...mapActions([                
          'getSubscriptionURL',
      ]),
      authorize() {
        const token = localStorage.getItem("token");
        console.log(token);
        if(!token){
          this.$router.push("/pages/login")
        } else {
          const response = fetch(`${process.env.VUE_APP_URL}api/users/authorize`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('response', response)
        }
      },
      getMembershipUrl() {
        
          let membership_level = localStorage.getItem("membership_level");
          // if (membership_level < 1000)
          //   this.membership_pg_url ="https://sospesosoftwares.com/#pricing"
          // else
          //   this.membership_pg_url ="https://goaltraders.com.br/#pricing"
          this.getSubscriptionURL({ membership_level: membership_level}).then((data) => {
              if (data.sub_url)
                this.membership_pg_url = data.sub_url;
              else
                this.membership_pg_url = "https://sospesosoftwares.com/#pricing";
              
          }).finally(() => {
              
          });
      },
      color (value) {
        let $color
        if (value <= 25) {
          $color = 'info'
        } else if (value > 25 && value <= 50) {
          $color = 'success'
        } else if (value > 50 && value <= 75) {
          $color = 'warning'
        } else if (value > 75 && value <= 100) {
          $color = 'danger'
        }
        return $color
      }
    }
  }
</script>
<style lang="scss" scoped>
  .upgrage_plan > a{
    text-decoration: none;
    color: white;
  }
  .plan_horizon{
    position: absolute;
    top: 0;
    width: 40%;
    margin: 0 auto;
    background-color: blue;
    left: -50%;
    right: -50%;
  }
  .main_plan_letters{
    margin-top: 270px;
    position: relative;
    text-align: center;
  }
  .plan_button_parent{
    text-align: center;
  }
  .plan_button_parent > button{
    background-color: blue;
    color: white;
    border: none;
    border-radius: 7px;
    padding: 8px 30px;
  }
  @media (max-width: 576px) {
    .main_plan_letters{
      margin-top: 200px;
    }
    .plan_horizon{
      width: 100%;
    }
  }
</style>